import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const { authenticated, login, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (authenticated) {
      navigate('/', { replace: true });
    }
  }, [authenticated, navigate]);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '2rem'
    }}>
      <div className="details-card" style={{ maxWidth: '400px', textAlign: 'center' }}>
        <h2 style={{ marginBottom: '1rem', color: '#032E36' }}>Login Required</h2>
        <p style={{ marginBottom: '2rem', color: '#6c757d' }}>
          Please log in to access the Metrics Management system.
        </p>
        <button className="btn btn-primary" onClick={login} style={{ width: '100%' }}>
          Login with Keycloak
        </button>
      </div>
    </div>
  );
};

export default Login;

